var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLikeUserActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2785_412)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.65625 7.875H0.84375C0.377754 7.875 0 8.25275 0 8.71875V17.1562C0 17.6222 0.377754 18 0.84375 18H3.65625C4.12225 18 4.5 17.6222 4.5 17.1562V8.71875C4.5 8.25275 4.12225 7.875 3.65625 7.875ZM2.25 16.5938C1.784 16.5938 1.40625 16.216 1.40625 15.75C1.40625 15.284 1.784 14.9062 2.25 14.9062C2.716 14.9062 3.09375 15.284 3.09375 15.75C3.09375 16.216 2.716 16.5938 2.25 16.5938ZM13.5 2.86355C13.5 4.35473 12.587 5.19117 12.3301 6.1875H15.9063C17.0804 6.1875 17.9945 7.16295 18 8.23001C18.0029 8.86064 17.7347 9.53954 17.3166 9.95959L17.3127 9.96346C17.6585 10.7839 17.6023 11.9335 16.9855 12.7573C17.2907 13.6677 16.983 14.7859 16.4095 15.3855C16.5606 16.0041 16.4884 16.5307 16.1934 16.9546C15.4759 17.9855 13.6974 18 12.1936 18L12.0935 18C10.3959 17.9994 9.00661 17.3813 7.89026 16.8846C7.32927 16.6351 6.59577 16.3261 6.03925 16.3159C5.80932 16.3117 5.625 16.124 5.625 15.8941V8.37872C5.625 8.26622 5.67007 8.15825 5.75009 8.07915C7.14277 6.703 7.74162 5.24602 8.88311 4.10259C9.40356 3.58116 9.59284 2.79352 9.77583 2.03182C9.93217 1.38139 10.2592 0 10.9688 0C11.8125 0 13.5 0.28125 13.5 2.86355Z",
    fill: "url(#paint0_linear_2785_412)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2785_412",
    x1: 8.99999,
    y1: 0,
    x2: 8.99999,
    y2: 18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3984FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0043B1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2785_412"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeUserActive);
export default __webpack_public_path__ + "static/media/Like_user_active.487e00b7bf7e96f144a9cfe6238aaaea.svg";
export { ForwardRef as ReactComponent };